import { useState } from "react";
import TabsSelection from "../../../shared-components/TabsSelection";
import { SubscriptionsTable } from "./SubscriptionsTable";

const tabs = [
  { identifier: "active", label: "Active" },
  { identifier: "cancelled", label: "Cancelled" },
];

const Subscriptions = () => {
  const [selectedTab, setSelectedTab] = useState<string>("active");

  return (
    <>
      <TabsSelection
        tabs={tabs}
        initial={selectedTab}
        onChange={(tab) => setSelectedTab(tab.identifier)}
      />

      {selectedTab === "active" && (
        <div className="mt-4">
          <SubscriptionsTable type="active" />
        </div>
      )}
      {selectedTab === "cancelled" && (
        <div className="mt-4">
          <SubscriptionsTable type="cancelled" />
        </div>
      )}
    </>
  );
};

export default Subscriptions;
